/* TAMANHO DO ID */
export const idSize = 16;

/* CARACTERES DO ID */
// export const alphabet = "0123456789abcdefghijklmnopqrstuvwxyz";

/* CRIAÇÃO DE UMA KEY (CONCATENANDO NOME COM ID) */
// export const formatarID = (nome: string, id: string): string => {
//   return `${nome
//     .normalize("NFD")
//     .replace(/[\u0300-\u036f]/g, "")
//     .toLowerCase()
//     .replace(/\s/g, "-")}_${id}`;
// };
